import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.overlay = document.querySelector('.js-nav-overlay');
        this.panels = document.querySelector('.js-nav-overlay-panels');
        this.panel = this.el.dataset.panel;
        this.panelEl = document.querySelector('#' + this.panel);
        this.back = this.panelEl.querySelector('.js-nav-overlay-panel-back');

        this.el.addEventListener('click', () => {
            const isActive = this.overlay.classList.contains('is-active') && this.panelEl.classList.contains('is-active');
            document.querySelectorAll('.c-nav-overlay__panel').forEach((el) => {
                el.classList.remove('is-active');
            });
            if (isActive) {
                this.overlay.classList.remove('is-active');
                this.panelEl.classList.remove('is-active');
            } else {
                this.overlay.classList.add('is-active');
                this.panelEl.classList.add('is-active');
            }
        });

        this.back.addEventListener('click', () => {
            this.overlay.classList.remove('is-active');
            this.panelEl.classList.remove('is-active');
        });
    }
}
